import { FC, useContext, useEffect, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { CommonContext, useApi } from '@repo-level/core-front';

import { AddonsContext } from 'contexts/addons';
import { registrationBanner as fetchRegistrationBanner } from 'api/cms/registrationBanner';
import { Spinner } from 'components/Spinner';

import { ScRegistrationBanner } from '../styled';
import { useIsLanding } from 'modules/promoLandings/hooks/useIsLanding';

export const RegistrationBanner: FC = () => {
  const {
    i18n: { language },
  } = useTranslation();

  const { customOffer } = useContext(AddonsContext);
  const { regBanner } = useContext(CommonContext);
  const { isLanding } = useIsLanding();

  const customBonusOffer = useMemo(
    () => (customOffer?.bonuses ? customOffer.bonuses[0].offer : null),
    [customOffer]
  );

  const [
    requestRegistrationBanner,
    { data: registrationBanner, pending: pendingRegistrationBanner },
  ] = useApi(fetchRegistrationBanner);

  useEffect(() => {
    requestRegistrationBanner(language);
  }, [requestRegistrationBanner, language]);

  const currentTitle =
    regBanner?.title || (registrationBanner && registrationBanner.title);
  const currentOffer1 = regBanner?.offer1 ?? registrationBanner?.offerLine_1;
  const currentOffer2 = isLanding
    ? regBanner?.offer2 || null
    : registrationBanner?.offerLine_2;

  return (
    <ScRegistrationBanner>
      {pendingRegistrationBanner ? (
        <Spinner size={32} />
      ) : (
        <>
          {registrationBanner && (
            <div className="offers">
              <div className="title">{currentTitle}</div>
              <div className="offer">
                {customBonusOffer ? (
                  <p>{customBonusOffer}</p>
                ) : (
                  <>
                    <p>{currentOffer1}</p>
                    {currentOffer2 && <p>{currentOffer2}</p>}
                  </>
                )}
              </div>
            </div>
          )}
        </>
      )}
    </ScRegistrationBanner>
  );
};
